// extracted by mini-css-extract-plugin
export var content = "desken-module--content--816a2";
export var data = "desken-module--data--aa8b4";
export var deskContent = "desken-module--desk-content--3e7aa";
export var deskGrid = "desken-module--desk-grid--4a7a4";
export var intro = "desken-module--intro--448f9";